import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { message, Skeleton } from "antd";
import useFetchProducts from "../../hooks/useFetchProducts";
import ProductCard from "../../components/cards/ProductCard.jsx";

const ProductPage = () => {
    const { productid } = useParams();
    const { products, loading } = useFetchProducts();
    const [product, setProduct] = useState(null);

    useEffect(() => {
        const foundProduct = products.find((prod) => prod.id === productid);

        if (foundProduct) {
            setProduct(foundProduct);
        } else {
            setProduct(null);
            message.error("Товар не найден!");
        }
    }, [productid, products]);

    if (loading) {
        return (
            <div className="p-4">
                <div className="h-screen grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                    {[...Array(4)].map((_, index) => (
                        <Skeleton.Node
                            key={index}
                            active
                            shape="square"
                            size="large"
                            style={{
                                width: "100%",
                                height: "220px",
                            }}
                        />
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="p-4">
            <div className="h-screen grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                <ProductCard product={product} />
            </div>
        </div>
    );
};

export default ProductPage;